import Searcher from './container';

export default Searcher;



// WEBPACK FOOTER //
// ./src/components/Searcher/index.js